import './ChatRoom.css'
import {LeftOutlined,FileImageFilled } from '@ant-design/icons'
import {Avatar, Button,Input} from 'antd'
import {useNavigate,useLocation} from 'react-router-dom'
import { useEffect,useState } from 'react';
import { auth,db, storage } from '../Login/Config';
import {collection,query,where,onSnapshot, orderBy,Timestamp,addDoc} from 'firebase/firestore'
import {ref,getDownloadURL,uploadBytes,deleteObject, getStorage} from 'firebase/storage'
import Message from './Message';
export default function ChatRoom(){
    let navigate = useNavigate()
    let location = useLocation()
    const [userChat,setUserChat] = useState('')
    const [msgs,setMsgs] = useState([])
    const [text,setText] = useState('')
    const id = new URLSearchParams(location.search)
    const backtoContactList = () =>{
        navigate('/contactlist')
    }
    useEffect(()=>{
        const user1 = auth.currentUser.uid
        const user2 = id.get('idRoom')
        const userChatRef = collection(db,'users')
        const u = query(userChatRef,where('uid','==',user2))
        onSnapshot(u,querySnapshot=>{
            let userChat=[]
            querySnapshot.forEach(doc=>{
                userChat.push(doc.data())
            })
            setUserChat(userChat)
        })
        const idRoom = user1 > user2 ? `${user1 + user2}` : `${user2 + user1}`
        const msgsRef = collection(db,'messages',idRoom,'chat')
        const q = query(msgsRef,orderBy('createAt','asc'))
        onSnapshot(q,querySnapshot=>{
            let msgs=[]
            querySnapshot.forEach(doc=>{
                msgs.push(doc.data())
            })
            setMsgs(msgs)
        })
    },[])
    const [img,setImg] = useState('')
    const handleSubmit = async(e) =>{
        e.preventDefault()
        const user1 = auth.currentUser.uid
        const user2 = id.get('idRoom')
        const idRoom = user1 > user2 ? `${user1 + user2}` : `${user2 + user1}`
        const d = new Date();
        let url
        if(img){
            const imgRef = ref(
                storage,
                `images/${img.name}`
            )
            const snap = await uploadBytes(imgRef,img)
            const dlurl = await getDownloadURL(ref(storage,snap.ref.fullPath))
            url = dlurl
        }

        await addDoc(collection(db,'messages',idRoom,'chat'),{
            text,
            from:user1,
            to:user2,
            createAt:Timestamp.fromDate(new Date()),
            time:`${d.getHours()}:${d.getMinutes()} ${d.getDate()}/${d.getMonth()+1}/${d.getFullYear()}`,
            img: url || ''
        })
        setText('')
        setImg('')
    }
    return(
        <div style={{width:'100%',height:'100vh',display:'flex',justifyContent:'center',backgroundColor:'#ccc'}}>
            <div className="chatroom">
                <div className='chatroom-header'>
                    <LeftOutlined onClick={backtoContactList} style={{color:'white',fontSize:'3vmin',marginRight:'1vw'}}/>
                    {userChat.length !== 0 ? <><Avatar style={{marginRight:'1vw'}} src={userChat[0].avt}></Avatar>
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-evenly'}}>
                        <h2 style={{margin:'0',color:'white',fontSize:'2.5vmin'}} className='userChat-name'>{userChat[0].name}</h2>
                        <p style={{margin:'0',color:'white',fontSize:'2vmin'}} className='userChat-isOnline'>{userChat[0].isOnline ? 'Đang hoạt động' : 'Offline'}</p> 
                    </div></> : <></>}
                </div>
                <div className='chatroom-container'>
                    <div className='chatroom-message'>
                     {msgs.length !== 0 ? msgs.map((message,index)=>(
                        <Message key={index} text={message.text} createAt={message.time} img={message.img} from={message.from}/>)):<></>}  
                    </div>
                    <Input.Group compact className='chatroom-input'>
                        <label htmlFor='img'>
                            <FileImageFilled className='chatroom-input-photo' style={{color:'rgb(24, 144, 255)'}}/>
                        </label>
                        <input type='file' style={{display:'none'}} id='img' accept='image/*' onChange={e=>setImg(e.target.files[0])}/>
                        <Input style={{ width: '78%',borderRadius:'20px',marginLeft:'1vw'}} placeholder='Nhập tin nhắn' value={text} onChange={e=>setText(e.target.value)}/>
                        <Button type="primary" style={{borderRadius:'20px',marginLeft:'0.5vw'}} onClick={handleSubmit}>Gửi</Button>
                    </Input.Group>
                </div>
            </div>
        </div>
    )
}